module.exports = __webpack_public_path__ + "static/media/et.e6b6f9d7.svg";